import { request } from 'graphql-request'
import {BaseProvider} from './gitUtils'

const FILE_COUNT_LIMIT = 50000;

export default class SourceGraphProvider < BaseProvider
	url = "https://sourcegraph.com/.api/graphql"

	get headers
		{'Accept': 'application/vnd.github.object'}

	get repository
		"{source}/{owner}/{repo}"

	def getRef(owner, repo)
		const query = '''
			query ($repository: String!) {
				repository(name: $repository) {
					defaultBranch {
						target {
							oid
						}
					}
				}
			}
		'''
		const variables = {repository}
		const res = await request(url, query, variables)
		unless res.repository
			# console.log "::noref sg vars", variables
			throw Error("ref in source graph not found")

		res.repository.defaultBranch.target.oid

	def loadFolderContent({ fullPath, recursive = no })
		const query = '''
			query($repository: String!, $ref: String!, $path: String!, $recursive: Boolean = false) {
				repository(name: $repository) {
					commit(rev: $ref) {
						tree(path: $path) {
							entries(first: 50000, recursive: $recursive, recursiveSingleChild: false) {
								fullPath: path
								isDirectory
							}
						}
					}
				}
			}
		'''
		const variables = {repository, ref, path: fullPath, recursive,}
		const res = await request(url, query, variables)
		const result = res.repository..commit..tree..entries

		unless result
			# console.log "::load folders sg vars", variables
			throw Error("error fetching folder from sg")

		result.map do(item) {...item, path: item.fullPath.replace(fullPath, '').replace('/', '')}

	def loadFileContent({fullPath})
		const query = '''
			query ($repository: String!, $ref: String!, $path: String!) {
				repository(name: $repository) {
					commit(rev: $ref) {
						blob(path: $path) {
							content
							binary
						}
					}
				}
			}
		'''
		const variables = {repository, ref, path: fullPath}
		const res = await request(url, query, variables)


		const result = res.repository..commit..blob

		unless result
			# console.log "::load file sg vars", variables
			throw Error("error fetching file content from sg")

		if result.binary
			'binary'
		else
			result.content

global.SourceGraphProvider = SourceGraphProvider
